import React from 'react'
import "./OrderInfoForModal.css";
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate } from '../../../../../utils/common';

const OrderInfoForModal = ({ order, onHide }) => {

    // const formatDate = (date) => {
    //     const options = {
    //         hour: '2-digit',
    //         minute: '2-digit',
    //         hour12: true
    //     };

    //     // Get day and add the appropriate suffix
    //     const day = date?.getDate();
    //     const daySuffix = (day) => {
    //         if (day > 3 && day < 21) return 'th'; // handle 11th, 12th, 13th
    //         switch (day % 10) {
    //             case 1: return 'st';
    //             case 2: return 'nd';
    //             case 3: return 'rd';
    //             default: return 'th';
    //         }
    //     };

    //     // Format month and year
    //     const monthOptions = { month: 'short' };
    //     const month = new Intl.DateTimeFormat('en-US', monthOptions).format(date);

    //     // Format time
    //     const time = new Intl.DateTimeFormat('en-US', options).format(date);

    //     // Combine day with suffix and other formatted parts
    //     return `${day}${daySuffix(day)} ${month}. | ${time.toLowerCase()}`;
    // };

    console.log(order, 'orderorderorder');

    return (
        <section className="OrderInfoForModal">

            <div className='profile_main_holder'>

                <div className='img_text_holder'>
                    <div className="profile_img_holder">
                        <img
                            src='/assets/images/logo/logo.png'
                            className='logo'
                        />
                    </div>
                    <div className='text_holder'>
                        <p className='odrer_id'>{`Order ID #${order?.invoice_no || order?.Product_Order?.invoice_no}`}</p>
                        <p className='amount'>Total Amount : ₹ {Number(order?.total_amount).toFixed(2)}</p>
                        <p className='date_text'>{formatDate(order?.createdAt)}</p>
                    </div>
                </div>

                <div className='close_div'>
                    <img src='/assets/images/cart/close.png' className='close_img' onClick={() => { onHide() }} />
                </div>

            </div>

        </section>
    )
}

export default OrderInfoForModal
